import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Phone, Mail } from 'lucide-react'

export default function Footer() {
  const [services, setServices] = useState([])

  useEffect(() => {
    fetch('/_api/public/content/services')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setServices(data.filter((s) => s.published !== false))
        }
      })
      .catch((err) => console.error('Fejl ved hentning af ydelser til footer:', err))
  }, [])

  return (
    <footer className="relative border-t border-zinc-900 bg-black text-[#f1f1f1]">
      {/* Decorative top gold line */}
      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-amber-500/50 to-transparent" />

      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="group inline-block">
              <img
                src="https://assets.auxodev.dk/assets/f44d6781-9183-40b0-88fc-e2c1542ad3e6/86054219-a7e4-4879-b662-316ddd7c6cb7.png"
                alt="DJ Ron9 Logo"
                width="160"
                height="48"
                loading="lazy"
                decoding="async"
                className="h-10 sm:h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </Link>
            <p className="text-sm text-[#f1f1f1]/80 leading-relaxed">
              Professionel DJ til bryllup, firmafest, fødselsdag og eksklusive events. Jeg leverer den vildeste fest med lyd og lys i topklasse.
            </p>
            <div className="flex items-center gap-2 text-xs text-zinc-600">
              <span>CVR: 34924139</span>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">
              Ydelser
            </h3>
            <ul className="mt-4 space-y-2">
              {services.map((service) => {
                const text = `${service.service_slug?.da || ''} ${service.slug?.da || ''} ${service.title?.da || ''}`.toLowerCase()
                let targetUrl = `/ydelser/${service.service_slug?.da || service.slug?.da || ''}`
                if (text.includes('bryllup')) targetUrl = '/dj-til-bryllup'
                else if (text.includes('firmafest')) targetUrl = '/lej-dj-til-firmafest'
                else if (text.includes('foedselsdag') || text.includes('fødselsdag')) targetUrl = '/dj-til-foedselsdag'
                else if (text.includes('sax')) targetUrl = '/dj-og-saxofon'
                else if (text.includes('vinyl')) targetUrl = '/vinyl-dj'

                return (
                  <li key={service.id}>
                    <Link
                      to={targetUrl}
                      className="text-sm text-[#f1f1f1] transition-colors hover:text-amber-400"
                    >
                      {service.title?.da}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>

          {/* Navigation Column */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">
              Navigation
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-[#f1f1f1] transition-colors hover:text-amber-400">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om" className="text-sm text-[#f1f1f1] transition-colors hover:text-amber-400">
                  Om DJ Ron9
                </Link>
              </li>
              <li>
                <Link to="/anmeldelser" className="text-sm text-[#f1f1f1] transition-colors hover:text-amber-400">
                  Anmeldelser
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-[#f1f1f1] transition-colors hover:text-amber-400">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm text-[#f1f1f1] transition-colors hover:text-amber-400">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">
              Kontakt DJ Ron9
            </h3>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-white" />
                <a
                  href="mailto:ronni@djron9.dk"
                  className="text-sm text-[#f1f1f1] transition-colors hover:text-amber-400 break-all"
                >
                  ronni@djron9.dk
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-zinc-900 pt-8 text-center md:flex md:items-center md:justify-between">
          <p className="text-xs text-zinc-600">
            &copy; {new Date().getFullYear()} DJ Ron9. Alle rettigheder forbeholdes.
          </p>
          <p className="mt-2 text-xs text-zinc-600 md:mt-0">
            Designet med fokus på eksklusivitet og festenergi.
          </p>
        </div>
      </div>
    </footer>
  )
}
